// app/javascript/controllers/driving_school_program_selection_list_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenInPersonProgram", "hiddenRemoteProgram", "toggleShowButton"]

  connect() {
    this.updateButtonText()
  }

  toggleShow() {
    this.hiddenInPersonProgramTargets.forEach(program => {
      program.classList.toggle("u-hidden")
    })
    this.hiddenRemoteProgramTargets.forEach(program => {
      program.classList.toggle("u-hidden")
    })

    this.updateButtonText()
  }

  updateButtonText() {
    if (!this.hasToggleShowButtonTarget) return
    
    const hasHiddenInPerson = this.hiddenInPersonProgramTargets.some(program => 
      program.classList.contains("u-hidden")
    )
    const hasHiddenRemote = this.hiddenRemoteProgramTargets.some(program => 
      program.classList.contains("u-hidden")
    )
    
    const hasAnyHidden = hasHiddenInPerson || hasHiddenRemote
    this.toggleShowButtonTarget.textContent = hasAnyHidden 
      ? "Show more" 
      : "Show fewer"
  }
}